export default "__VITE_ASSET__Xj16XU7B__"